export default "__VITE_ASSET__7589de68__"